import React from 'react';
import { Button, ButtonGroup} from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

function LeagueTypeButton() {
    const location = useLocation();

    const locationSplit = location['pathname'].split('/');
    const leagueType = locationSplit[1];
    const playerType = locationSplit[2];
    const playerId = locationSplit[3];

    function leagueTypeCalc(btnType) {
        if(btnType === "major" && leagueType === "major") {
            return 'active';
        } else if(btnType === "minor" && leagueType === "minor") {
            return 'active';
        } else {
            return '';
        }
    }

    function leagueTypeClickEventHandler(event) {
        let leagueValue = event.target.value;

        if(leagueValue !== leagueType) {
            window.location.href = `/${leagueValue}/${playerType}/${playerId}`;
        }
    }

    return (
        <>
        <ButtonGroup aria-label="Basic example" style={{float: 'left', marginLeft: '5px'}}>
            <Button 
            variant="secondary" size="sm" value="major" 
            active={leagueTypeCalc("major")}
            onClick={leagueTypeClickEventHandler}>1군</Button>
            <Button 
            variant="secondary" size="sm" value="minor" 
            active={leagueTypeCalc("minor")}
            onClick={leagueTypeClickEventHandler}>2군</Button>
        </ButtonGroup>
        </>
    )
}

export default LeagueTypeButton;